import React from 'react';
import Modal from 'react-modal';
import { useTranslation } from 'react-i18next';

import './modalCouponStyles.css';
import closeImg from 'styles/assets/close.svg';

export function ModalCoupon({ storeInfo, isOpen, onRequestClose, storeUrl }) {
  const { t } = useTranslation();
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      overlayClassName="react-modal-overlay"
      className="react-modal-content"
    >
      <button
        type="button"
        onClick={onRequestClose}
        className="react-modal-close"
      >
        <img src={closeImg} alt="Fechar modal" />
      </button>
      <div className="container-modal">
        <h3 className="title-modal-coupon">{storeInfo.description}</h3>
        {t('modalCoupon.cupom')}{' '}
        <span className="container-coupon">{storeInfo.checkoutCode}</span>
        <div className="copy-coupon-description">
          {t('modalCoupon.copy_code')}
        </div>
        <span>{storeInfo.detailsDescription}</span>
        <a href={storeUrl} target="new">
          <button className="button-visit-store">
            {t('modalCoupon.visit_store')}
          </button>
        </a>
      </div>
    </Modal>
  );
}
